import React from 'react';
import './AISkeletonLoader.css';

const AISkeletonLoader: React.FC = () => {
  return (
    <div className="ai-skeleton-card">
      <div className="ai-skeleton-header">
        <div className="ai-skeleton-icon">
          <svg width="18" height="18" viewBox="0 0 20 20" fill="none" className="sparkle-placeholder">
            <path d="M10 2L12.5 7.5L18 10L12.5 12.5L10 18L7.5 12.5L2 10L7.5 7.5L10 2Z" fill="#e5e7eb" />
          </svg>
        </div>
        <div className="skeleton-line ai-header-text"></div>
      </div>
      <div className="ai-skeleton-content">
        <div className="skeleton-line skeleton-long"></div>
        <div className="skeleton-line skeleton-medium"></div>
        <div className="skeleton-line skeleton-long"></div>
        <div className="skeleton-line skeleton-short"></div>
        <div className="skeleton-line skeleton-medium"></div>
        <div className="skeleton-line skeleton-long"></div>
      </div>
    </div>
  );
};

export default AISkeletonLoader;
